// OuterLayout.js

import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import { Outlet, useNavigate } from "react-router-dom";

import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import { makeStyles } from "@material-ui/core/styles";

import {
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";

import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import Footer from "components/UpdateUi/Footer/Footer";

import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";

import { useSelector } from "react-redux";

import HeaderOuter from "components/UpdateUi/Header/HeaderOuter";

import brandTheme from "brandTheme/Theme";
import { enableGetTheAppButton } from "assets/properties/properties";
import { getDeviceType } from "utils/Utils";

let ps;

const useStyles = makeStyles(styles);

export default function OuterLayout({ ...rest }) {
  const classes = useStyles();

  const navigate = useNavigate();

  const { authToken } = useSelector(
    (state) => state.login.authData
  );

  const mainPanel = useRef(null);

  const [mobileOpen, setMobileOpen] = useState(false);

  const [outletData, setOutletData] = useState({});

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  useEffect(() => {
    if (authToken) {
      getUserDetails();
    }
  }, [authToken]);

  const getUserDetails = async () => {
    try {
      const result = await apiHandler({
        url: endpoint.USER_DETAIL,
        authToken,
      });

      setOutletData(result?.data || {});
    } catch (error) {
      console.log("USER DETAILS ERROR:", error);
    }
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };


  const closeDrawerAndNavigate = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  const handleRepay = () => {
    sessionStorage.setItem("RepaymentFlag", "true");
    navigate("/login");
    setMobileOpen(false);
  };
  const device = getDeviceType();
    const enableGetTheAppBtn = enableGetTheAppButton && device !=="ios"
  return (
    <div className={classes.wrapper}>
      <div
        className={classes.mainPanel}
        ref={mainPanel}
      >
        {/* HEADER */}
        <HeaderOuter
          handleDrawerToggle={handleDrawerToggle}
          userDetailData={outletData}
        />

        {/* MOBILE DRAWER */}
        <Drawer
          anchor="top"
          open={mobileOpen}
          onClose={handleDrawerToggle}
        >
          <div
            style={{
              width: '100%',
              paddingTop: 20,
            }}
          >
            <List>
              <ListItem
                button
                onClick={() =>
                  closeDrawerAndNavigate("/welcome")
                }
              >
                <ListItemText primary="Home" />
              </ListItem>

              <ListItem
                button
                onClick={() =>
                  closeDrawerAndNavigate("/about")
                }
              >
                <ListItemText primary="About" />
              </ListItem>

              <ListItem
                button
                onClick={() =>
                  closeDrawerAndNavigate("/contact")
                }
              >
                <ListItemText primary="Contact" />
              </ListItem>

              <ListItem
                button
                onClick={handleRepay}
              >
                <ListItemText primary="Repay" />
              </ListItem>

              <ListItem
                button
                className={classes.drawerGetApp}
                onClick={() =>{
                      setMobileOpen(false);
                if(enableGetTheAppBtn){
                window.open(
                  "https://play.google.com/store/apps/details?id=com.personalloanapp",
                  "_blank",
                  "noopener,noreferrer"
                )
              }else{
                navigate("/login")
              }
          }}
              >
                <ListItemText primary= {enableGetTheAppBtn ? "Get the App" : "Sign In"} />
              </ListItem>
            </List>
          </div>
        </Drawer>

        {/* PAGE CONTENT */}
        <div
          style={{ display: "flex" }}
        >
          <div className={classes.content}>
            <div
              className={
                classes.container
              }
            >
              <Outlet />
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <Footer />
      </div>
    </div>
  );
}